const SCROLL_EVENT_TYPES = new Set(['touchmove', 'wheel', 'mousewheel']);

const originalAddEventListener = EventTarget.prototype.addEventListener;

EventTarget.prototype.addEventListener = function addEventListener(type, handler, options) {
  if (!SCROLL_EVENT_TYPES.has(type)) {
    return originalAddEventListener.call(this, type, handler, options);
  }

  let newOptions;

  if (options == null) {
    newOptions = { passive: false };
  } else if (typeof options === 'boolean') {
    newOptions = { capture: options, passive: false };
  } else if (options.passive !== undefined) {
    newOptions = options;
  } else {
    newOptions = { ...options, passive: false };
  }

  return originalAddEventListener.call(this, type, handler, newOptions);
};
